import dynamic from 'next/dynamic'
import { useInView } from 'react-intersection-observer'

import Image from '@web/components/Image'
import { gql } from '@web/gql'
import { VideoPlayerCard_MediaItemFragment } from '@web/gql/graphql'
import { ThumbnailType } from '@web/libs/media/photoInfra.constant'
import { neloLogger } from '@web/libs/utils'

const VideoContainer = dynamic(() => import('../ThumbnailVideoPlayer'), {
  ssr: false,
})

type Props = {
  videoItem: VideoPlayerCard_MediaItemFragment
  thumbnailType: ThumbnailType
  className?: string
  useLazyloading: boolean
}

const VideoPlayerCard = ({ videoItem, thumbnailType, className, useLazyloading }: Props) => {
  const { ref: viewRef, inView } = useInView({ threshold: 0.9 })

  if (videoItem.isIllegalVideo || !videoItem.playback) {
    neloLogger('warn', '[VideoPlayerCard] 불법 촬영물 혹은 playback api가 실패했습니다.', { videoItem })
    return (
      <Image
        className={className}
        src={videoItem.thumbnail}
        width="100%"
        alt=""
        thumbnailType={thumbnailType}
        lazyLoading={useLazyloading}
        isPlaybackError={!videoItem.isIllegalVideo && !videoItem.playback}
      />
    )
  }
  return (
    <div ref={viewRef} className={className}>
      <VideoContainer videoItem={videoItem} isPlay={inView} />
    </div>
  )
}

VideoPlayerCard.fragments = gql(`
  fragment VideoPlayerCard_MediaItem on VideoItem {
    id
    type
    thumbnail
    playback {
      url
    }
    isIllegalVideo
    ...ThumbnailVideoPlayer_VideoItem
  }
`)

export default VideoPlayerCard
